import { Row, Typography } from 'antd';
import React from 'react';

import { FontSize, FontWeight, LineHeight } from '@common/tokens';
import { PrevNextButtons } from '@common/components';
import { LoadingState } from '@common/components/loading-state';

const { Text } = Typography;

export const DateNavigationTitle = (props: {
  loading: boolean;
  onPrev: () => void;
  onNext: () => void;
  disablePrev?: boolean;
  disableNext?: boolean;
  children: React.ReactNode;
}) => (
  <>
    <Row align="middle">
      <PrevNextButtons
        disablePrev={props.disablePrev}
        disableNext={props.disableNext}
        onPrev={props.onPrev}
        onNext={props.onNext}
      />
      <Text className="wk-date-navigation-title__text">{props.children}</Text>
      <LoadingState loading={props.loading} size="sm" />
    </Row>
    <style jsx>{`
      :global(.wk-date-navigation-title__text) {
        padding-left: 16px;
        /* H3_Book */
        font-size: ${FontSize.xl};
        font-style: normal;
        font-weight: ${FontWeight.light};
        line-height: ${LineHeight.lg};
      }
    `}</style>
  </>
);
